import collection from "@/store/collection.store-partial";
import curveballModule from "@/store/game/curveballs/single.store";

export default {
	namespaced: true,
	modules: {
		collection,
	},
	state: {},
	getters: {
		active: (state, getters) => getters.array.find((curveball) => curveball.active),
	},
	actions: {
		configureApp: {
			root: true,
			handler({ dispatch }, { curveballs }) {
				const settings = { items: curveballs, path: ["game", "curveballs"], module: curveballModule };
				dispatch("populate", settings);
			},
		},
		activate({ dispatch }, curveball) {
			dispatch(`${curveball.id}/activate`);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/curveballs/list.store.js